import type { ReactElement } from "react";
import StatusIconWarningInverted from "ui/icons/status/IconWarningInverted";
import Tooltip from "ui/popovers/Tooltip";

const defaultMessage: ReactElement = (
  <>
    This reported value is possibly out of date.
    <br />
    Please re-publish the associated Home.
  </>
);

export default function WarnOutOfDate({
  size = 10,
  message = defaultMessage,
}: {
  size?: number;
  message?: ReactElement | string;
}) {
  return (
    <Tooltip.Root delayDuration={0}>
      <Tooltip.Trigger>
        <div
          style={{
            border: "none",
            display: "inline",
            position: "relative",
            top: 1,
            left: 3,
          }}
        >
          <StatusIconWarningInverted size={size} />
        </div>
      </Tooltip.Trigger>
      <Tooltip.Content>{message}</Tooltip.Content>
    </Tooltip.Root>
  );
}
